'use client';

import { useState, useEffect } from 'react';

interface Vendedor {
  id: number;
  nome: string;
}

interface FilterProps {
  onFilterChange: (filters: {
    startDate: string;
    endDate: string;
    vendedor: string;
  }) => void;
}

export function Filters({ onFilterChange }: FilterProps) {
  const [vendedores, setVendedores] = useState<Vendedor[]>([]);
  const [selectedVendedor, setSelectedVendedor] = useState('all');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  

  useEffect(() => {
    // Fetch vendedores
    fetch('/api/analytics/vendedores')
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setVendedores(data);
        } else {
          console.error('Invalid vendedores response:', data);
          setVendedores([]);
        }
      })
      .catch(err => {
        console.error('Error fetching vendedores:', err);
        setVendedores([]);
      });

    // Set default date range (last 90 days)
    // const end = new Date();
    // const start = new Date(end.getTime() - 90 * 24 * 60 * 60 * 1000);
    
    // setStartDate(start.toISOString().split('T')[0]);
    // setEndDate(end.toISOString().split('T')[0]);

    const today = new Date();
    const start = new Date(today.getFullYear(), today.getMonth(), 1);
    const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    
    setStartDate(start.toISOString().split('T')[0]);
    setEndDate(end.toISOString().split('T')[0]);
  }, []);

  const handleFilterChange = () => {
    onFilterChange({
      startDate,
      endDate,
      vendedor: selectedVendedor,
    });
  };

  useEffect(() => {
    if (startDate && endDate) {
      handleFilterChange();
    }
  }, [selectedVendedor, startDate, endDate]);

  return (
    <div
      className="rounded-lg border p-6 mb-8"
      style={{
        backgroundColor: 'var(--card-bg)',
        borderColor: 'var(--card-border-bright)',
        backdropFilter: 'blur(10px)',
        padding: '1.5rem',
      
      }}
    >
      <h2 className="text-lg font-bold mb-6 text-center p-4">Filtros</h2>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 justify-center" >
        <div>
          <label className="block text-sm font-medium text-slate-400 mb-2">Data Inicial</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="w-full px-4 py-3 rounded-lg bg-slate-700/30 border text-slate-200 text-center"
            style={{ borderColor: 'var(--card-border-bright)' }}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-400 mb-2">Data Final</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="w-full px-4 py-3 rounded-lg bg-slate-700/30 border text-slate-200 text-center"
            style={{ borderColor: 'var(--card-border-bright)' }}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-400 mb-2">Vendedor</label>
          <select
            value={selectedVendedor}
            onChange={(e) => setSelectedVendedor(e.target.value)}
            className="w-full px-4 py-3 rounded-lg bg-slate-700/30 border text-slate-200 text-center"
            style={{ borderColor: 'var(--card-border-bright)' }}
          >
            <option value="all">Todos os Vendedores</option>
            {vendedores.map(v => (
              <option key={v.id} value={String(v.id)}>{v.nome}</option>
            ))}
          </select>
        </div>

        <div className="flex items-end">
          <button
            onClick={handleFilterChange}
            className="w-full px-4 py-2 rounded-lg font-medium transition-all border"
            style={{
              backgroundColor: 'var(--accent)',
              color: '#fff',
              borderColor: 'var(--accent)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--accent-hover)';
              e.currentTarget.style.borderColor = 'var(--accent-hover)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--accent)';
              e.currentTarget.style.borderColor = 'var(--accent)';
            }}
          >
            Aplicar Filtros
          </button>
        </div>
      </div>
    </div>
  );
}
